import type { FC } from 'react';
import React from 'react';
import { Button } from 'common/common_components/Button/Button';
import { useGoogleLogin } from '@react-oauth/google';
import { useAppDispatch, useAppSelector } from 'store';
import { usersActions, usersSelectors } from 'store/slices';
interface SocialLoginProps {
  callback?: () => void;
}
export const SocialLogin: FC<SocialLoginProps> = ({ callback }) => {
  const dispatch = useAppDispatch();
  const isSocialLoginPending = useAppSelector(
    usersSelectors.selectIsSocialLoginPending,
  );
  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      dispatch(usersActions.socialLogin(codeResponse.access_token, callback));
    },

    onError: (error) => console.log('Login Failed:', error),
  });
  return (
    <Button
      content="Sign in with google"
      cssType="dark"
      isLoading={isSocialLoginPending}
      //@ts-ignore
      onClick={login}
    />
  );
};
